import {
	TOPICBUILDER_SEARCHING,
	TOPICBUILDER_SEARCH_ERROR,
	TOPICBUILDER_SEARCH_SUCCESS,
	TOPICBUILDER_SAVE_CURRENT_SEARCH,
	TERM_SELECT_AS_TARGET,
	TERM_SELECT_AS_IGNORED_RELATED,
	TERM_SELECT_AS_INCLUDE_SPECIFIC,
	TERM_SELECT_AS_IGNORE_SPECIFIC,
	BUILD_CONCEPT_UNSAVED,
	BULD_CONCEPT_LOADING_END,
	BUILD_CONCEPT_CURRENT_FILTER_CHANGE,
	SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
	SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS,
	RANGE_FILTER_SAVING_START,
	RANGE_FILTER_SAVING_END,
	BUILD_CONCEPT_SAVE_CURRENT_UUID,
	BUILD_CONCEPT_FIND_DOCUMENTS,
	BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
	BUILD_CONCEPT_CLEAR_TERMS,
	BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY,
	BUILD_CONCEPT_UPDATE_DOCUMENT_DATE,
	BUILD_CONCEPT_SET_SOURCE_FILTER,
	BUILD_CONCEPT_FORCE_FILTER_REFRESH,
	BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	BUILD_CONCEPT_SEARCHING_DOCS,
	UPDATE_LAST_CONCEPTS_CALL,
	BUILD_CONCEPT_IS_LOADING_DOCS,
	BUILD_CONCEPT_CLEAR_BUTTON,
	BUILD_CONCEPT_CLEAR_ALL,
	SELECTED_BUILD_CONCEPT,
	UPDATE_BUILD_CONCEPT_METADATA,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED,
	REQUEST_SAVE_CONCEPT,
	REQUEST_SAVE_CONCEPT_SUCCESS,
	REQUEST_SAVE_CONCEPT_FAILED,
	REQUEST_SAVE_CONCEPT_CLEAR,
	SET_P_SEARCH_API_CALL,
	RESET_P_SEARCH_API_CALL,
	SET_SEARCH_TERMS,
	SET_REFRESH_TERM_LIST,
	SET_TARGET_TERMS,
} from "../types"

//cada reducer tiene su propio state
const initialState = {
	topicBuilderResults: [],
	highlight_concepts: {
		positive: [],
		negative: [],
	},
	topicBuilderCurrentAction: {},
	targetTerms: [],
	ignoreTerms: [],
	includeSpecificTerms: [],
	ignoreSpecificTerms: [],
	searchTerms: [],
	error: null,
	loading: false,
	loading_docs: false,
	unsaved_data: false,
	currentFilter: {
		phrase_count: 15,
		neg_phrase_count: 2,
		share: 0,
		isSaving: false,
	},
	user_saved_build_concepts: [],
	user_saved_build_concepts_shared: [],
	user_saved_build_concepts_unshared: [],
	loadedAPIData: {},
	currentUUID: null,
	concept_docs: {
		count: 0,
		data: {},
	},
	request_documents_need: false,
	force_tag_refresh: false,
	force_filter_refresh: false,
	sourceFilter: {
		doc: true,
		xls: true,
		ppt: true,
		pdf: true,
		txt: true,
		email: true,
		fromDate: "",
		toDate: "",
	},
	searching_doc: false,
	last_concepts_saved_request: null,
	clear_button: false,
	selectedConcept: undefined,
	loadConceptsError: null,
	isConceptSaved: false,
	isConceptSaving: false,
	callPsearch: false,
	isRefreshTermList: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case BUILD_CONCEPT_IS_LOADING_DOCS:
			return { ...state, loading_docs: action.payload }
		case UPDATE_LAST_CONCEPTS_CALL:
			return { ...state, last_concepts_saved_request: new Date().getTime() }
		case BUILD_CONCEPT_SEARCHING_DOCS:
			return { ...state, searching_doc: action.payload }
		case BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS:
			return { ...state, highlight_concepts: action.payload }
		case BUILD_CONCEPT_SET_SOURCE_FILTER:
			return { ...state, sourceFilter: action.payload }

		case BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY:
			try {
				let index = state.concept_docs.data.findIndex((data) => data.id === action.payload.id)
				let aux_concept_docs = state.concept_docs
				aux_concept_docs.data[index]["tags"] = action.payload.priority
				return {
					...state,
					concept_docs: aux_concept_docs,
				}
			} catch (error) {
				return { ...state }
			}

		case BUILD_CONCEPT_UPDATE_DOCUMENT_DATE:
			try {
				let index = state.concept_docs.data.findIndex((data) => data.id === action.payload.id)
				let aux_concept_docs = state.concept_docs
				aux_concept_docs.data[index]["tagged_date"] = action.payload.date

				return {
					...state,
					concept_docs: aux_concept_docs,
				}
			} catch (error) {
				return { ...state }
			}

		case UPDATE_BUILD_CONCEPT_METADATA:
			const payload = action.payload
			const currentData = { ...state.concept_docs }
			const iIndex = Array.isArray(currentData.data) ? currentData.data.findIndex((data) => data.id === payload.id) : -1 //find the id
			if (iIndex !== -1) {
				let updateRecord = currentData.data[iIndex] //get the object
				updateRecord = { ...updateRecord, ...payload.data } //update the object
				currentData.data[iIndex] = updateRecord //assign bakc to list
			}
			return {
				...state,
				concept_docs: currentData,
			}
		case BUILD_CONCEPT_FORCE_CLOUD_REFRESH:
			return {
				...state,
				force_tag_refresh: action.payload,
			}
		case BUILD_CONCEPT_FORCE_FILTER_REFRESH:
			return {
				...state,
				force_filter_refresh: action.payload,
			}
		case BUILD_CONCEPT_CLEAR_TERMS:
			return {
				...state,
				targetTerms: [],
				ignoreTerms: [],
				includeSpecificTerms: [],
				ignoreSpecificTerms: [],
				searchTerms: [],
				concept_docs: {
					count: 0,
					data: {},
				},
			}
		case BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS:
			return { ...state, request_documents_need: action.payload }
		case BUILD_CONCEPT_FIND_DOCUMENTS:
			return {
				...state,
				concept_docs: action.payload,
				loadConceptsError: null,
			}
		case REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR:
			return {
				...state,
				concept_docs: {
					count: 0,
					data: {},
				},
			}
		case GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED:
			return {
				...state,
				loadConceptsError: action.payload,
			}
		case BUILD_CONCEPT_SAVE_CURRENT_UUID:
			return {
				...state,
				currentUUID: action.payload,
			}
		case RANGE_FILTER_SAVING_START:
			var aux = { ...state.currentFilter }
			aux.isSaving = true
			return {
				...state,
				currentFilter: aux,
			}
		case RANGE_FILTER_SAVING_END:
			// eslint-disable-next-line
			var aux = { ...state.currentFilter }
			aux.isSaving = false
			return {
				...state,
				currentFilter: aux,
			}
		case SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS:
			//topic has 3 key (count, relatedness and terms that we have to conver in multidimensional array list an add it to topicBuilderResults)
			let auxTopicResult = []
			action.payload.topic.count.forEach(function (individualTopic, index) {
				auxTopicResult.push([individualTopic, action.payload.topic.terms[index], action.payload.topic.relatedness[index]])
			})
			let auxFilter = state.currentFilter
			auxFilter.share = action.payload.shared
			auxFilter.phrase_count = action.payload.visual.phrase_count
			auxFilter.neg_phrase_count = action.payload.visual.neg_phrase_count

			let fullTerms = action.payload.topic.terms
			let auxTargetTerms = action.payload.visual.terms?.map((term) => term?.toLowerCase())
			let auxIgnoreTerms = action.payload.visual.ignore
			//let auxIncludeSpecificTerms = ((action.payload.visual.soft_include === null ||  action.payload.visual.soft_include ===undefined)? [] : action.payload.visual.soft_include);
			let auxIncludeSpecificTerms = action.payload.visual.soft_target
			let auxIgnoreSpecificTerms = action.payload.visual.soft_ignore
			//Remove the terms that are not in topic.terms
			auxTargetTerms = auxTargetTerms.filter(function (i) {
				return this.indexOf(i) !== -1
			}, fullTerms)
			auxIgnoreTerms = auxIgnoreTerms.filter(function (i) {
				return this.indexOf(i) !== -1
			}, fullTerms)
			auxIncludeSpecificTerms = auxIncludeSpecificTerms.filter(function (i) {
				return this.indexOf(i) !== -1
			}, fullTerms)
			auxIgnoreSpecificTerms = auxIgnoreSpecificTerms.filter(function (i) {
				return this.indexOf(i) !== -1
			}, fullTerms)

			let theSearchTerms = action?.payload?.visual?.search_terms || []
			let updatedSearchTerms = action?.payload?.topic?.terms?.filter((term) => !theSearchTerms?.includes(term)) || []

			return {
				...state,
				loadedAPIData: action.payload,
				topicBuilderResults: auxTopicResult,
				targetTerms: auxTargetTerms,
				ignoreTerms: auxIgnoreTerms,
				includeSpecificTerms: auxIncludeSpecificTerms,
				ignoreSpecificTerms: auxIgnoreSpecificTerms,
				loading: false,
				currentFilter: auxFilter,
				force_filter_refresh: true,
				searchTerms: updatedSearchTerms,
				isRefreshTermList: true,
			}
		case SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS:
			// console.log(action.payload);
			return {
				...state,
				user_saved_build_concepts: action.payload,
				user_saved_build_concepts_shared: action.payload.filter((item) => item.shared === 1),
				user_saved_build_concepts_unshared: action.payload.filter((item) => item.shared !== 1),
			}
		case BUILD_CONCEPT_CURRENT_FILTER_CHANGE:
			return {
				...state,
				currentFilter: action.payload,
			}
		case BUILD_CONCEPT_UNSAVED:
			return {
				...state,
				unsaved_data: action.payload,
			}
		case TOPICBUILDER_SEARCHING:
			return {
				...state,
				loading: action.payload,
			}
		case BULD_CONCEPT_LOADING_END:
			return {
				...state,
				loading: action.payload,
			}
		case TOPICBUILDER_SEARCH_SUCCESS:
			let auxArray = []
			action.payload.data.count.forEach(function (individualTopic, index) {
				auxArray.push([individualTopic, action.payload.data.terms[index], action.payload.data.relatedness[index]])
			})

			return {
				...state,
				loading: false,
				targetTerms: action.payload.topic.target_terms,
				ignoreTerms: action.payload.topic.ignore_terms,
				includeSpecificTerms: action.payload.topic.soft_target,
				ignoreSpecificTerms: action.payload.topic.soft_ignore,
				topicBuilderResults: auxArray,
			}
		case TOPICBUILDER_SEARCH_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			}
		case TOPICBUILDER_SAVE_CURRENT_SEARCH:
			return {
				...state,
				topicBuilderCurrentAction: action.payload,
			}
		case TERM_SELECT_AS_TARGET:
			if (action.payload.add === true) {
				var arrayA = [...state.targetTerms]
				var index = arrayA.indexOf(action.payload.term)
				if (index === -1) {
					return {
						...state,
						targetTerms: [...state.targetTerms, action.payload.term],
					}
				} else {
					return {
						...state,
					}
				}
			} else {
				//is remove
				// eslint-disable-next-line
				var arrayA = [...state.targetTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index !== -1) {
					arrayA.splice(index, 1)
					return {
						...state,
						targetTerms: arrayA,
					}
				}
				return { ...state }
			}
		case SET_TARGET_TERMS:
			return {
				...state,
				targetTerms: action.payload,
			}
		case SET_SEARCH_TERMS:
			return {
				...state,
				searchTerms: action?.payload || [],
			}
		case TERM_SELECT_AS_IGNORED_RELATED:
			if (action.payload.add === true) {
				// eslint-disable-next-line
				var arrayA = [...state.ignoreTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index === -1) {
					return {
						...state,
						ignoreTerms: [...state.ignoreTerms, action.payload.term],
					}
				} else {
					return {
						...state,
					}
				}
			} else {
				//is remove
				// eslint-disable-next-line
				var arrayA = [...state.ignoreTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index !== -1) {
					arrayA.splice(index, 1)
					return {
						...state,
						ignoreTerms: arrayA,
					}
				}
				return { ...state }
			}
		case TERM_SELECT_AS_INCLUDE_SPECIFIC:
			if (action.payload.add === true) {
				// eslint-disable-next-line
				var arrayA = [...state.includeSpecificTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index === -1) {
					return {
						...state,
						includeSpecificTerms: [...state.includeSpecificTerms, action.payload.term],
					}
				} else {
					return {
						...state,
					}
				}
			} else {
				//is remove
				// eslint-disable-next-line
				var arrayA = [...state.includeSpecificTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index !== -1) {
					arrayA.splice(index, 1)
					return {
						...state,
						includeSpecificTerms: arrayA,
					}
				}
				return { ...state }
			}

		case TERM_SELECT_AS_IGNORE_SPECIFIC:
			if (action.payload.add === true) {
				// eslint-disable-next-line
				var arrayA = [...state.ignoreSpecificTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index === -1) {
					return {
						...state,
						ignoreSpecificTerms: [...state.ignoreSpecificTerms, action.payload.term],
					}
				} else {
					return {
						...state,
					}
				}
			} else {
				//is remove
				// eslint-disable-next-line
				var arrayA = [...state.ignoreSpecificTerms]
				// eslint-disable-next-line
				var index = arrayA.indexOf(action.payload.term)
				if (index !== -1) {
					arrayA.splice(index, 1)
					return {
						...state,
						ignoreSpecificTerms: arrayA,
					}
				}
				return { ...state }
			}
		case BUILD_CONCEPT_CLEAR_BUTTON:
			return {
				...state,
				clear_button: action.payload,
			}
		case BUILD_CONCEPT_CLEAR_ALL:
			return {
				...initialState,
				user_saved_build_concepts: state.user_saved_build_concepts,
				user_saved_build_concepts_shared: state.user_saved_build_concepts_shared,
				user_saved_build_concepts_unshared: state.user_saved_build_concepts_unshared,
			}

		case SELECTED_BUILD_CONCEPT:
			return {
				...state,
				selectedConcept: action.payload,
			}
		case REQUEST_SAVE_CONCEPT:
			return {
				...state,
				isConceptSaved: false,
				isConceptSaving: true,
			}
		case REQUEST_SAVE_CONCEPT_SUCCESS:
			return {
				...state,
				isConceptSaved: true,
				isConceptSaving: false,
			}
		case REQUEST_SAVE_CONCEPT_FAILED:
			return {
				...state,
				isConceptSaved: false,
				isConceptSaving: false,
				error: action?.payload,
			}
		case REQUEST_SAVE_CONCEPT_CLEAR:
			return {
				...state,
				isConceptSaved: false,
				isConceptSaving: false,
				error: undefined,
			}
		case SET_P_SEARCH_API_CALL:
			return {
				...state,
				callPsearch: true,
			}
		case RESET_P_SEARCH_API_CALL:
			return {
				...state,
				callPsearch: false,
			}
		case SET_REFRESH_TERM_LIST:
			return {
				...state,
				isRefreshTermList: action.payload,
			}
		default:
			return state
	}
}
